import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Features from "@/components/site/Features";
import HowItWorks from "@/components/site/HowItWorks";
import ForWhom from "@/components/site/ForWhom";
import Partners from "@/components/site/Partners";
import Stats from "@/components/site/Stats";
import CtaSection from "@/components/site/CtaSection";
import Footer from "@/components/site/Footer";
import { useReveal } from "@/hooks/useReveal";

const Index = () => {
  useReveal();
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main>
        <Hero />
        <Features />
        <HowItWorks />
        <ForWhom />
        <Partners />
        <Stats />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
